import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import Checkbox from "../../ui-library/Checkbox/Checkbox";

const StyledCheckboxInput = styled(Checkbox)`
  margin-right: 5px;
`;

const TermsCheckbox = (props) => {
  const { onChange, policyHref } = props;

  const { t } = useTranslation();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    onChange(checked);
  }, [checked, onChange]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setChecked((prevState) => !prevState);
    }
  };

  return (
    <div data-testid="terms-checkbox">
      <label
        className="privacy-terms mt-3 d-flex"
        tabIndex="0"
        onKeyPress={handleKeyPress}
      >
        <StyledCheckboxInput
          checked={checked}
          onClick={() => setChecked((prevState) => !prevState)}
          icon={true}
          square={true}
        />

        <span
          dangerouslySetInnerHTML={{
            __html: t("appText.privacyPolicy.notice.checkbox.label", {
              link: policyHref,
            }),
          }}
        />
      </label>
    </div>
  );
};
export default withTheme(TermsCheckbox);
